import { Box, MenuItem, Select } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCalendarDays } from "@fortawesome/pro-solid-svg-icons"

import { LocalizedEnum } from "../../../../../localization/components/AppLocalized"
import { DatePeriod } from "../../../../../../shared/components/filters/selectDatePeriodFilter/SelectDatePeriodFilter"

const PERIOD_OPTIONS: readonly DatePeriod[] = [
    DatePeriod.TODAY,
    DatePeriod.TOMORROW,
    DatePeriod.THIS_WEEK,
    DatePeriod.THIS_MONTH,
] as const

const useStyles = makeStyles()((theme) => ({
    select: {
        minWidth: "11rem",
        borderRadius: ".75rem",
        background: theme.palette.common.white,
        color: theme.palette.tailwind.slate[800],
        fontSize: "1rem",
        "& .MuiOutlinedInput-notchedOutline": {
            borderColor: theme.palette.tailwind.slate[300],
        },
        "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: theme.palette.tailwind.slate[300],
        },
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: theme.palette.tailwind.slate[300],
            borderWidth: "1px",
        },
        "& .MuiSelect-select": {
            display: "flex",
            alignItems: "center",
            gap: ".5rem",
            padding: ".625rem 2.5rem .625rem 1rem",
        },
    },
    calendarIcon: {
        fontSize: "1rem",
        color: theme.palette.tailwind.slate[800],
    },
}))

type DashboardPeriodPickerProps = Readonly<{
    datePeriod: DatePeriod
    onChange: (period: DatePeriod) => void
}>

export function DashboardPeriodPicker({ datePeriod, onChange }: DashboardPeriodPickerProps) {
    const { classes } = useStyles()

    return (
        <Select
            value={datePeriod}
            onChange={(event) => onChange(event.target.value as DatePeriod)}
            className={classes.select}
            renderValue={(value) => (
                <Box display="flex" alignItems="center" gap=".5rem">
                    <FontAwesomeIcon icon={faCalendarDays} className={classes.calendarIcon} />
                    <LocalizedEnum base="table-select-date-period-filter-by" enumValue={value as DatePeriod}>
                        <span>{value}</span>
                    </LocalizedEnum>
                </Box>
            )}
        >
            {PERIOD_OPTIONS.map((period) => (
                <MenuItem key={period} value={period}>
                    <LocalizedEnum base="table-select-date-period-filter-by" enumValue={period}>
                        <span>{period}</span>
                    </LocalizedEnum>
                </MenuItem>
            ))}
        </Select>
    )
}
